import { useCallback } from 'react';
import { useFeedback } from '../FeedbackContext';
import { haptics } from '../utils/haptics';

// Opt-in at the financial action boundary, not in the toast or form callback.
// A single completed action emits one result haptic, including status changes.
export const useFinancialFeedback = () => {
  const { showSuccess, showError } = useFeedback();
  const financialSuccess = useCallback((...args) => {
    showSuccess(...args);
    void haptics.success();
  }, [showSuccess]);
  const financialError = useCallback((...args) => {
    showError(...args);
    void haptics.error();
  }, [showError]);

  return { showSuccess: financialSuccess, showError: financialError };
};
